import { Box as T, Fade as h, Zoom as F, Grow as N, Collapse as C } from "@mui/material";
import { DEFAULT_ANIMATE_DURATION as D, ANIMATION_TYPE as n } from "../../../constants/layout.js";
import { useState as r, useCallback as I, useEffect as s } from "react";
import { jsx as o, Fragment as b } from "react/jsx-runtime";
const L = T, M = (e) => {
  switch (e) {
    case n.COLLAPSE:
      return C;
    case n.GROW:
      return N;
    case n.ZOOM:
      return F;
    case n.FADE:
    default:
      return h;
  }
}, v = (e) => {
  const {
    children: m,
    className: c,
    delay: i = 0,
    removeOnHide: t = !1,
    timeout: l = D,
    type: u = n.FADE,
    ...f
  } = e, [A, d] = r((e.in || !0) && i === 0), [E, a] = r(!t), O = M(u), x = I(() => {
    t && a(!1);
  }, [t]);
  return s(() => {
    t && e.in && a(!0);
  }, [e.in, t]), s(() => {
    i > 0 && setTimeout(() => d(!0), i);
  }, [i]), E ? /* @__PURE__ */ o(O, {
    in: A,
    timeout: l,
    onExited: x,
    ...f,
    children: /* @__PURE__ */ o(L, {
      className: c,
      children: m
    })
  }) : /* @__PURE__ */ o(b, {});
};
export {
  v as default
};
//# sourceMappingURL=AnimatedBox.js.map
